var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 993,
    height: 215,
    viewBox: "0 0 993 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4627_123274)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 993,
    height: 215,
    rx: 16,
    fill: "#E4F8F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4627_123274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.382,
    cy: 204.907,
    r: 61.0933,
    fill: "#189FAA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter1_f_4627_123274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.0933,
    cy: 61.0933,
    r: 61.0933,
    fill: "#189FAA"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4627_123274)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 34.5205H-33.2227V68.7798H1.03661V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.695452,
    cy: 34.8631,
    r: 33.5741,
    transform: "rotate(90 0.695452 34.8631)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32.8788,
    cy: 68.4371,
    r: 33.5741,
    transform: "rotate(90 -32.8788 68.4371)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.591 171.556H172.332V205.815H206.591V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.25,
    cy: 171.898,
    r: 33.5741,
    transform: "rotate(90 206.25 171.898)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.676,
    cy: 205.472,
    r: 33.5741,
    transform: "rotate(90 172.676 205.472)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 0.257812H1.03125V34.5171H35.2905V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.37486,
    cy: 0.600445,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9491,
    cy: 34.1744,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 68.7773H138.082V103.037H172.341V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.426,
    cy: 69.12,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 34.5203H206.586V68.7795H240.845V34.5203Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.93,
    cy: 34.8629,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.504,
    cy: 68.4369,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 34.5205H69.5547V68.7798H103.814V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.8983,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.473,
    cy: 68.4371,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 171.556H206.586V205.815H240.845V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.717,
    cy: 171.556,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 0.257812H-33.2227V34.5171H1.03661V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -16.0919,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 34.5205H138.082V68.7798H172.341V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.213,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 34.5205H35.3047V68.7798H69.5639V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.4355,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 34.5205H1.03125V68.7798H35.2905V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.37486,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 68.7773H35.3047V103.037H69.5639V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.2225,
    cy: 69.12,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.2206,
    cy: 69.12,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 103.035H309.383V137.294H343.642V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.301,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.299,
    cy: 103.378,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 103.035H446.414V137.294H480.673V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.332,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.33,
    cy: 103.378,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 137.293H412.141V171.552H446.4V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.058,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.057,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 137.293H514.941V171.552H549.201V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.859,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 103.035H514.941V137.294H549.201V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.859,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 0.257812H206.586V34.5171H240.845V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.504,
    cy: 0.600445,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.502,
    cy: 0.600515,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 -34H275.109V0.259262H309.369V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.027,
    cy: -33.6574,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 137.293H138.082V171.552H172.341V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.998,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 137.293H343.637V171.552H377.896V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.555,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.553,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 103.035H206.586V137.294H240.845V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.504,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.502,
    cy: 103.378,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 205.813H309.383V240.073H343.642V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.301,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.299,
    cy: 206.156,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 103.035H377.891V137.294H412.15V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.808,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.807,
    cy: 103.378,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 34.5205H514.941V68.7798H549.201V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.859,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.591 34.5203H172.332V68.7795H206.591V34.5203Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.676,
    cy: 34.8629,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.674,
    cy: 34.863,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 68.7773H343.637V103.037H377.896V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.98,
    cy: 69.12,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.978,
    cy: 69.12,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 0.257812H480.668V34.5171H514.927V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: 0.600445,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.01,
    cy: 0.600515,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 -34H446.414V0.259262H480.673V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.758,
    cy: -33.6574,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 68.7773H-33.2227V103.037H1.03661V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.695171,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.693289,
    cy: 102.694,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 171.556H138.082V205.815H172.341V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.998,
    cy: 205.472,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.595 68.7773H172.336V103.037H206.595V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.254,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.252,
    cy: 102.694,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 0.257812H35.3047V34.5171H69.5639V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.2225,
    cy: 34.1744,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 -34H-33.2227V0.259262H1.03661V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.695452,
    cy: -33.6574,
    r: 33.5741,
    transform: "rotate(90 0.695452 -33.6574)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32.8788,
    cy: -0.0833946,
    r: 33.5741,
    transform: "rotate(90 -32.8788 -0.0833946)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 68.7773H1.03125V103.037H35.2905V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.162,
    cy: 103.037,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 205.813H206.586V240.073H240.845V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 205.813H446.414V240.073H480.673V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 171.556H514.941V205.815H549.201V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.072,
    cy: 205.815,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 103.035H1.03125V137.294H35.2905V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9494,
    cy: 103.378,
    r: 33.5741,
    transform: "rotate(90 34.9494 103.378)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.37514,
    cy: 136.952,
    r: 33.5741,
    transform: "rotate(90 1.37514 136.952)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 68.7773H240.859V103.037H275.119V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.777,
    cy: 69.12,
    r: 33.5741,
    transform: "rotate(90 274.777 69.12)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: 102.694,
    r: 33.5741,
    transform: "rotate(90 241.203 102.694)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 -34H377.891V0.259262H412.15V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.809,
    cy: -33.6574,
    r: 33.5741,
    transform: "rotate(90 411.809 -33.6574)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.235,
    cy: -0.0833946,
    r: 33.5741,
    transform: "rotate(90 378.235 -0.0833946)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 0.257812H275.109V34.5171H309.369V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.027,
    cy: 0.600443,
    r: 33.5741,
    transform: "rotate(90 309.027 0.600443)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.453,
    cy: 34.1744,
    r: 33.5741,
    transform: "rotate(90 275.453 34.1744)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 34.5205H343.637V68.7798H377.896V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.555,
    cy: 34.8631,
    r: 33.5741,
    transform: "rotate(90 377.555 34.8631)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.981,
    cy: 68.4371,
    r: 33.5741,
    transform: "rotate(90 343.981 68.4371)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 0.257812H446.414V34.5171H480.673V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.332,
    cy: 0.600443,
    r: 33.5741,
    transform: "rotate(90 480.332 0.600443)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.758,
    cy: 34.1744,
    r: 33.5741,
    transform: "rotate(90 446.758 34.1744)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 68.7773H412.141V103.037H446.4V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.059,
    cy: 69.12,
    r: 33.5741,
    transform: "rotate(90 446.059 69.12)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.485,
    cy: 102.694,
    r: 33.5741,
    transform: "rotate(90 412.485 102.694)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 68.7773H480.668V103.037H514.927V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.586,
    cy: 69.12,
    r: 33.5741,
    transform: "rotate(90 514.586 69.12)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: 102.694,
    r: 33.5741,
    transform: "rotate(90 481.012 102.694)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 205.813H103.809V240.073H138.068V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.727,
    cy: 206.156,
    r: 33.5741,
    transform: "rotate(90 137.727 206.156)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.152,
    cy: 239.73,
    r: 33.5741,
    transform: "rotate(90 104.152 239.73)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.591 103.035H172.332V137.294H206.591V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.25,
    cy: 103.378,
    r: 33.5741,
    transform: "rotate(90 206.25 103.378)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.676,
    cy: 136.952,
    r: 33.5741,
    transform: "rotate(90 172.676 136.952)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 137.293H103.809V171.552H138.068V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.727,
    cy: 137.636,
    r: 33.5741,
    transform: "rotate(90 137.727 137.636)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.152,
    cy: 171.21,
    r: 33.5741,
    transform: "rotate(90 104.152 171.21)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 171.556H412.141V205.815H446.4V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.059,
    cy: 171.898,
    r: 33.5741,
    transform: "rotate(90 446.059 171.898)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.485,
    cy: 205.472,
    r: 33.5741,
    transform: "rotate(90 412.485 205.472)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 171.556H35.3047V205.815H69.5639V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.2228,
    cy: 171.898,
    r: 33.5741,
    transform: "rotate(90 69.2228 171.898)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.6486,
    cy: 205.472,
    r: 33.5741,
    transform: "rotate(90 35.6486 205.472)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 205.813H240.859V240.073H275.119V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.777,
    cy: 206.156,
    r: 33.5741,
    transform: "rotate(90 274.777 206.156)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: 239.73,
    r: 33.5741,
    transform: "rotate(90 241.203 239.73)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 -34H69.5547V0.259262H103.814V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.473,
    cy: -33.6574,
    r: 33.5741,
    transform: "rotate(90 103.473 -33.6574)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.8986,
    cy: -0.0833946,
    r: 33.5741,
    transform: "rotate(90 69.8986 -0.0833946)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 -34H206.586V0.259262H240.845V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.846,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 103.035H35.3047V137.294H69.5639V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5644,
    cy: 120.165,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 68.7773H206.586V103.037H240.845V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.846,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 -34H35.3047V0.259262H69.5639V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.4355,
    cy: 0.259207,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 171.556H69.5547V205.815H103.814V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5566,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 205.813H35.3047V240.073H69.5639V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.3066,
    cy: 222.943,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 103.035H275.109V137.294H309.369V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.111,
    cy: 120.165,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 171.556H343.637V205.815H377.896V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.639,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 205.813H514.941V240.073H549.201V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.943,
    cy: 222.943,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 68.7773H69.5547V103.037H103.814V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5566,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 -34H103.809V0.259262H138.068V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.81,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 0.257812H138.082V34.5171H172.341V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.084,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 0.257812H377.891V34.5171H412.15V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.893,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 34.5205H412.141V68.7798H446.4V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.143,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 -34H412.141V0.259262H446.4V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.143,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 34.5205H480.668V68.7798H514.927V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.67,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 68.7773H446.414V103.037H480.673V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.416,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.595 0.257812H172.336V34.5171H206.595V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.338,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.591 137.293H172.332V171.552H206.591V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.334,
    cy: 154.422,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip74_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 0.257812H103.809V34.5171H138.068V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.068,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 0.257812H240.859V34.5171H275.119V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.119,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip76_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 0.257812H309.383V34.5171H343.642V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.643,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 34.5205H275.109V68.7798H309.369V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.369,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip78_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.591 -34H172.332V0.259262H206.591V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.592,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 -34H1.03125V0.259262H35.2905V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.2909,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip80_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 103.035H103.809V137.294H138.068V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.939,
    cy: 103.035,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip81_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 68.7773H103.809V103.037H138.068V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip82_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 68.7773H309.383V103.037H343.642V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip83_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 0.257812H69.5547V34.5171H103.814V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip84_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 103.035H138.082V137.294H172.341V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip85_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 103.035H69.5547V137.294H103.814V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.8983,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.473,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip86_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 205.813H1.03125V240.073H35.2905V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.37486,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9491,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip87_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 171.556H-33.2227V205.815H1.03661V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32.879,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.695171,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip88_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 137.293H240.859V171.552H275.119V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: 137.635,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.777,
    cy: 171.209,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip89_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 171.556H309.383V205.815H343.642V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.726,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.301,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip90_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 205.813H377.891V240.073H412.15V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.234,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.808,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip91_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 205.813H480.668V240.073H514.927V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.586,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip92_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 103.035H-33.2227V137.294H1.03661V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32.879,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip93_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 103.035H240.859V137.294H275.119V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip94_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 -34H240.859V0.259262H275.119V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip95_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 34.5205H103.809V68.7798H138.068V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.152,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.15,
    cy: 34.8632,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip96_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 137.293H275.109V171.552H309.369V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.453,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.451,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip97_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 171.556H480.668V205.815H514.927V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.01,
    cy: 171.898,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip98_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 137.293H-33.2227V171.552H1.03661V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32.879,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip99_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 137.293H1.03125V171.552H35.2905V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9491,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip100_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 -34H138.082V0.259262H172.341V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.426,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.424,
    cy: -0.0833225,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip101_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 137.293H35.3047V171.552H69.5639V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.6483,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.6464,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip102_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 34.5203H240.859V68.7795H275.119V34.5203Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: 34.8629,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.201,
    cy: 34.863,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip103_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 -34H343.637V0.259262H377.896V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.98,
    cy: -33.6574,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip104_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 34.5205H309.383V68.7798H343.642V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.726,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.725,
    cy: 34.8632,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip105_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 205.813H275.109V240.073H309.369V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.453,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.451,
    cy: 206.156,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip106_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.068 171.556H103.809V205.815H138.068V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.726,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip107_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 205.813H412.141V240.073H446.4V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.058,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip108_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 137.293H446.414V171.552H480.673V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.332,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip109_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.845 137.293H206.586V171.552H240.845V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.504,
    cy: 171.209,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip110_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 137.293H309.383V171.552H343.642V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.301,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip111_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 137.293H69.5547V171.552H103.814V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.473,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip112_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.595 205.813H172.336V240.073H206.595V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.254,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip113_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2905 171.556H1.03125V205.815H35.2905V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9491,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip114_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 205.813H343.637V240.073H377.896V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.555,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip115_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.814 205.813H69.5547V240.073H103.814V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.473,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip116_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 171.556H275.109V205.815H309.369V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.24,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip117_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 171.556H446.414V205.815H480.673V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.545,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip118_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.673 34.5205H446.414V68.7798H480.673V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.545,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip119_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 0.257812H412.141V34.5171H446.4V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.271,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip120_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 68.7773H377.891V103.037H412.15V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.021,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip121_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 -34H514.941V0.259262H549.201V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.072,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip122_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 0.257812H343.637V34.5171H377.896V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.768,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip123_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03661 205.813H-33.2227V240.073H1.03661V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -16.0919,
    cy: 222.943,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip124_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.119 171.556H240.859V205.815H275.119V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.203,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip125_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 137.293H480.668V171.552H514.927V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip126_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.896 103.035H343.637V137.294H377.896V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.98,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip127_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 0.257812H514.941V34.5171H549.201V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.285,
    cy: 34.1744,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip128_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 103.035H412.141V137.294H446.4V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.484,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip129_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 34.5205H377.891V68.7798H412.15V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.234,
    cy: 68.4371,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip130_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 -34H480.668V0.259262H514.927V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip131_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 171.556H377.891V205.815H412.15V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.234,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip132_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.927 103.035H480.668V137.294H514.927V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.012,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip133_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.369 68.7773H275.109V103.037H309.369V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.453,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip134_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.642 -34H309.383V0.259262H343.642V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.726,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip135_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.341 205.813H138.082V240.073H172.341V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.426,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip136_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15 137.293H377.891V171.552H412.15V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.021,
    cy: 154.423,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip137_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.201 68.7773H514.941V103.037H549.201V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.072,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip138_4627_123274)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip139_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 -34H514.625V0.259262H548.884V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.756,
    cy: 0.259207,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip140_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 -34H548.879V0.259262H583.138V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.139,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip141_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 0.257812H548.879V34.5171H583.138V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.797,
    cy: 0.600443,
    r: 33.5741,
    transform: "rotate(90 582.797 0.600443)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.223,
    cy: 34.1744,
    r: 33.5741,
    transform: "rotate(90 549.223 34.1744)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip142_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 34.5205H617.406V68.7798H651.666V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.324,
    cy: 34.8631,
    r: 33.5741,
    transform: "rotate(90 651.324 34.8631)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.75,
    cy: 68.4371,
    r: 33.5741,
    transform: "rotate(90 617.75 68.4371)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip143_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 171.556H822.961V205.815H857.22V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856.879,
    cy: 171.898,
    r: 33.5741,
    transform: "rotate(90 856.879 171.898)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.305,
    cy: 205.472,
    r: 33.5741,
    transform: "rotate(90 823.305 205.472)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip144_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 0.257812H651.656V34.5171H685.916V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 0.600445,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.574,
    cy: 34.1744,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip145_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 68.7773H788.707V103.037H822.966V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 789.051,
    cy: 69.12,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.625,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip146_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 34.5205H857.211V68.7798H891.47V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 857.555,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.129,
    cy: 68.4371,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip147_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 34.5203H720.18V68.7795H754.439V34.5203Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.523,
    cy: 34.8629,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.098,
    cy: 68.4369,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip148_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 0.257812H514.625V34.5171H548.884V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.756,
    cy: 0.257742,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip149_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 171.556H857.211V205.815H891.47V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874.342,
    cy: 171.556,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip150_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 0.257812H583.152V34.5171H617.412V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.154,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip151_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 0.257812H617.406V34.5171H651.666V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.537,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip152_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 34.5203H788.707V68.7795H822.966V34.5203Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 805.838,
    cy: 51.6498,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip153_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 34.5205H685.93V68.7798H720.189V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.06,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip154_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 -34H583.152V0.259262H617.412V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.496,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip155_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 34.5205H651.656V68.7798H685.916V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip156_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 68.7773H685.93V103.037H720.189V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.848,
    cy: 69.12,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.846,
    cy: 69.12,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip157_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 103.035H960.008V137.294H994.267V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.926,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.924,
    cy: 103.378,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip158_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 0.257812H857.211V34.5171H891.47V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.129,
    cy: 0.600445,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.127,
    cy: 0.600515,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip159_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 -34H925.734V0.259262H959.994V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 959.652,
    cy: -33.6574,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip160_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 137.293H788.707V171.552H822.966V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.625,
    cy: 137.635,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.623,
    cy: 137.635,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip161_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 103.035H857.211V137.294H891.47V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.129,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.127,
    cy: 103.378,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip162_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 205.813H960.008V240.073H994.267V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.926,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.924,
    cy: 206.156,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip163_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 34.5205H822.961V68.7798H857.22V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.305,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.303,
    cy: 34.8632,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip164_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 68.7773H617.406V103.037H651.666V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.324,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.322,
    cy: 102.694,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip165_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 171.556H788.707V205.815H822.966V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.625,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.623,
    cy: 205.472,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip166_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 68.7773H822.961V103.037H857.22V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856.879,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856.877,
    cy: 102.694,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip167_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 34.5205H548.879V68.7798H583.138V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.01,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip168_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 0.257812H685.93V34.5171H720.189V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.848,
    cy: 34.1744,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip169_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 -34H617.406V0.259262H651.666V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.324,
    cy: -33.6574,
    r: 33.5741,
    transform: "rotate(90 651.324 -33.6574)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.75,
    cy: -0.0833946,
    r: 33.5741,
    transform: "rotate(90 617.75 -0.0833946)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip170_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 68.7773H651.656V103.037H685.916V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.787,
    cy: 103.037,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip171_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 205.813H857.211V240.073H891.47V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip172_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 103.035H651.656V137.294H685.916V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.574,
    cy: 103.378,
    r: 33.5741,
    transform: "rotate(90 685.574 103.378)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 136.952,
    r: 33.5741,
    transform: "rotate(90 652 136.952)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip173_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 68.7773H891.484V103.037H925.744V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925.402,
    cy: 69.12,
    r: 33.5741,
    transform: "rotate(90 925.402 69.12)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: 102.694,
    r: 33.5741,
    transform: "rotate(90 891.828 102.694)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip174_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 0.257812H925.734V34.5171H959.994V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 959.652,
    cy: 0.600443,
    r: 33.5741,
    transform: "rotate(90 959.652 0.600443)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.078,
    cy: 34.1744,
    r: 33.5741,
    transform: "rotate(90 926.078 34.1744)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip175_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 205.813H754.434V240.073H788.693V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.352,
    cy: 206.156,
    r: 33.5741,
    transform: "rotate(90 788.352 206.156)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.777,
    cy: 239.73,
    r: 33.5741,
    transform: "rotate(90 754.777 239.73)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip176_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 103.035H822.961V137.294H857.22V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856.879,
    cy: 103.378,
    r: 33.5741,
    transform: "rotate(90 856.879 103.378)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.305,
    cy: 136.952,
    r: 33.5741,
    transform: "rotate(90 823.305 136.952)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip177_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 137.293H754.434V171.552H788.693V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.352,
    cy: 137.635,
    r: 33.5741,
    transform: "rotate(90 788.352 137.635)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.777,
    cy: 171.209,
    r: 33.5741,
    transform: "rotate(90 754.777 171.209)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip178_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 171.556H685.93V205.815H720.189V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.848,
    cy: 171.898,
    r: 33.5741,
    transform: "rotate(90 719.848 171.898)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.274,
    cy: 205.472,
    r: 33.5741,
    transform: "rotate(90 686.274 205.472)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip179_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 205.813H891.484V240.073H925.744V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925.402,
    cy: 206.156,
    r: 33.5741,
    transform: "rotate(90 925.402 206.156)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: 239.73,
    r: 33.5741,
    transform: "rotate(90 891.828 239.73)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip180_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 -34H720.18V0.259262H754.439V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.098,
    cy: -33.6574,
    r: 33.5741,
    transform: "rotate(90 754.098 -33.6574)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.524,
    cy: -0.0833946,
    r: 33.5741,
    transform: "rotate(90 720.524 -0.0833946)",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip181_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 34.5205H583.152V68.7798H617.412V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.412,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip182_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 -34H857.211V0.259262H891.47V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.471,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip183_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 103.035H685.93V137.294H720.189V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.189,
    cy: 120.165,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip184_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 68.7773H857.211V103.037H891.47V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.471,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip185_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 68.7773H583.152V103.037H617.412V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.283,
    cy: 103.037,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip186_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 205.813H514.625V240.073H548.884V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip187_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 -34H685.93V0.259262H720.189V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.06,
    cy: 0.259207,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip188_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 103.035H583.152V137.294H617.412V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.154,
    cy: 120.165,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip189_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 171.556H720.18V205.815H754.439V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.182,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip190_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 205.813H685.93V240.073H720.189V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.932,
    cy: 222.943,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip191_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 205.813H548.879V240.073H583.138V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.881,
    cy: 222.943,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip192_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 103.035H925.734V137.294H959.994V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925.736,
    cy: 120.165,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip193_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 68.7773H720.18V103.037H754.439V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.182,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip194_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 -34H754.434V0.259262H788.693V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.435,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip195_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 0.257812H788.707V34.5171H822.966V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.709,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip196_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 0.257812H822.961V34.5171H857.22V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.963,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip197_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 137.293H822.961V171.552H857.22V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.963,
    cy: 154.423,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip198_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 0.257812H754.434V34.5171H788.693V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.693,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip199_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 0.257812H891.484V34.5171H925.744V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925.744,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip200_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 0.257812H960.008V34.5171H994.267V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.268,
    cy: 17.3874,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip201_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 34.5205H925.734V68.7798H959.994V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 959.994,
    cy: 51.6501,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip202_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 -34H822.961V0.259262H857.22V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 857.221,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip203_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 -34H651.656V0.259262H685.916V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.916,
    cy: -16.8704,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip204_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 103.035H754.434V137.294H788.693V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 771.564,
    cy: 103.035,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip205_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 68.7773H548.879V103.037H583.138V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.01,
    cy: 68.7773,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip206_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 68.7773H754.434V103.037H788.693V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip207_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 68.7773H960.008V103.037H994.267V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip208_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 0.257812H720.18V34.5171H754.439V0.257812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip209_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 103.035H788.707V137.294H822.966V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip210_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 103.035H720.18V137.294H754.439V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.523,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.098,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip211_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 205.813H651.656V240.073H685.916V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.574,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip212_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 171.556H617.406V205.815H651.666V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.75,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.324,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip213_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 137.293H583.152V171.552H617.412V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.496,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.07,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip214_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 137.293H891.484V171.552H925.744V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925.402,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip215_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 171.556H960.008V205.815H994.267V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.351,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.926,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip216_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 103.035H617.406V137.294H651.666V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.75,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip217_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 103.035H891.484V137.294H925.744V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip218_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 -34H891.484V0.259262H925.744V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip219_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 34.5203H754.434V68.7795H788.693V34.5203Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.777,
    cy: 34.8629,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.775,
    cy: 34.863,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip220_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 137.293H925.734V171.552H959.994V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.078,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.076,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip221_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 34.5205H514.625V68.7798H548.884V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.543,
    cy: 68.4371,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.541,
    cy: 68.4372,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip222_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 137.293H617.406V171.552H651.666V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.75,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.748,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip223_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 103.035H548.879V137.294H583.138V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.223,
    cy: 103.378,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip224_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 137.293H651.656V171.552H685.916V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.574,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip225_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 -34H788.707V0.259262H822.966V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 789.051,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 789.049,
    cy: -0.0833225,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip226_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.189 137.293H685.93V171.552H720.189V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.273,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.271,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip227_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 34.5205H891.484V68.7798H925.744V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.826,
    cy: 34.8632,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip228_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 34.5205H960.008V68.7798H994.267V34.5205Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.351,
    cy: 34.8631,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.35,
    cy: 34.8632,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip229_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 137.293H548.879V171.552H583.138V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.223,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.221,
    cy: 137.636,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip230_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 205.813H583.152V240.073H617.412V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.496,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.494,
    cy: 206.156,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip231_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 205.813H925.734V240.073H959.994V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.078,
    cy: 206.156,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.076,
    cy: 206.156,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip232_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.138 171.556H548.879V205.815H583.138V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.797,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip233_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.693 171.556H754.434V205.815H788.693V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.351,
    cy: 171.898,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip234_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 103.035H514.625V137.294H548.884V103.035Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.543,
    cy: 136.952,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip235_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 137.293H514.625V171.552H548.884V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.543,
    cy: 137.636,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip236_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 68.7773H514.625V103.037H548.884V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.756,
    cy: 85.9069,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip237_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.412 171.556H583.152V205.815H617.412V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.07,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip238_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.47 137.293H857.211V171.552H891.47V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.129,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip239_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 137.293H960.008V171.552H994.267V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.926,
    cy: 171.21,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip240_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 137.293H720.18V171.552H754.439V137.293Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.098,
    cy: 171.209,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip241_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.22 205.813H822.961V240.073H857.22V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856.879,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip242_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.916 171.556H651.656V205.815H685.916V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.574,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip243_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.439 205.813H720.18V240.073H754.439V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.098,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip244_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.884 171.556H514.625V205.815H548.884V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.756,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip245_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 171.556H925.734V205.815H959.994V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942.865,
    cy: 188.685,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip246_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.666 205.813H617.406V240.073H651.666V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.537,
    cy: 222.943,
    r: 16.787,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip247_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.744 171.556H891.484V205.815H925.744V171.556Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.828,
    cy: 205.472,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip248_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.994 68.7773H925.734V103.037H959.994V68.7773Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.078,
    cy: 102.694,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip249_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.267 -34H960.008V0.259262H994.267V-34Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.351,
    cy: -0.0833931,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip250_4627_123274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.966 205.813H788.707V240.073H822.966V205.813Z",
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 789.051,
    cy: 239.73,
    r: 33.5741,
    stroke: "#719B9E",
    strokeOpacity: 0.14,
    strokeWidth: 0.685185
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4627_123274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 467.593,
    cy: 42.5933,
    r: 47.5933,
    fill: "#189FAA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4627_123274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 339.593,
    cy: 34.5933,
    r: 47.5933,
    fill: "#189FAA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4627_123274",
    x: -105.658,
    y: -108.133,
    width: 626.081,
    height: 626.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125.973,
    result: "effect1_foregroundBlur_4627_123274"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4627_123274",
    x: -193.042,
    y: -229.042,
    width: 580.272,
    height: 580.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 114.521,
    result: "effect1_foregroundBlur_4627_123274"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4627_123274",
    x: 223.727,
    y: -201.273,
    width: 487.734,
    height: 487.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 98.1365,
    result: "effect1_foregroundBlur_4627_123274"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4627_123274",
    x: 95.727,
    y: -209.273,
    width: 487.734,
    height: 487.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 98.1365,
    result: "effect1_foregroundBlur_4627_123274"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 993,
    height: 215,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 657.778,
    height: 370,
    fill: "white",
    transform: "translate(-136 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.332 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 34.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.332 34.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.336 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.332 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.336 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.332 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.332 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip92_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip93_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip94_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip95_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip96_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip97_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip98_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip100_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip101_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(35.3047 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip102_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 34.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip103_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip104_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip105_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip106_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(103.809 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip107_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip108_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip109_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(206.586 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip110_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip111_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip112_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(172.336 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip113_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(1.03125 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip114_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip115_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(69.5547 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip116_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip117_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip118_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(446.414 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip119_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip120_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip121_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip122_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip123_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(-33.2227 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip124_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(240.859 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip125_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip126_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(343.637 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip127_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip128_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(412.141 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip129_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip130_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip131_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip132_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(480.668 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip133_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(275.109 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip134_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(309.383 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip135_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(138.082 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip136_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(377.891 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip137_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.941 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip138_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 657.778,
    height: 370,
    fill: "white",
    transform: "translate(514.625 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip139_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip140_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip141_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip142_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip143_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip144_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip145_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip146_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip147_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 34.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip148_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip149_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip150_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip151_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip152_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 34.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip153_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip154_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip155_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip156_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip157_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip158_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip159_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip160_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip161_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip162_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip163_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip164_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip165_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip166_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip167_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip168_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip169_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip170_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip171_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip172_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip173_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip174_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip175_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip176_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip177_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip178_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip179_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip180_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip181_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip182_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip183_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip184_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip185_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip186_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip187_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip188_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip189_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip190_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip191_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip192_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip193_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip194_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip195_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip196_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip197_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip198_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip199_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip200_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip201_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip202_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip203_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip204_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip205_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip206_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip207_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip208_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 0.257812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip209_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip210_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip211_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip212_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip213_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip214_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip215_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip216_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip217_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip218_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip219_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 34.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip220_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip221_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip222_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip223_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip224_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip225_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip226_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(685.93 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip227_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip228_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 34.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip229_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip230_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip231_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip232_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(548.879 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip233_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(754.434 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip234_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 103.035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip235_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip236_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip237_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(583.152 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip238_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(857.211 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip239_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip240_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 137.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip241_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(822.961 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip242_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(651.656 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip243_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(720.18 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip244_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(514.625 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip245_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip246_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(617.406 205.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip247_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(891.484 171.556)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip248_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(925.734 68.7773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip249_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(960.008 -34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip250_4627_123274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2593,
    height: 34.2593,
    fill: "white",
    transform: "translate(788.707 205.813)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipcard);
export default __webpack_public_path__ + "static/media/Membershipcard.aa8f89d83bbbaf695b586456d6128d06.svg";
export { ForwardRef as ReactComponent };